import React, { useCallback } from "react";
import { useDropzone } from "react-dropzone";
import { withStyles } from "@material-ui/core";
import styles from "./styles";

import CloudUploadOutlinedIcon from "@material-ui/icons/CloudUploadOutlined";
import { useTranslation } from "react-i18next";

const Upload = ({ onFileUpload, classes, title, acceptFormats }) => {
  const { t } = useTranslation();
  const onDrop = useCallback((acceptedFiles) => {
    onFileUpload(acceptedFiles);
  }, []);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: acceptFormats,
  });

  return (
    <div className={classes.dropZone}>
      <div {...getRootProps()} className={classes.dropZoneInner}>
        <input {...getInputProps()} />
        <div className={[classes.centerAll]}>
          <CloudUploadOutlinedIcon
            style={{ fontSize: "4rem", marginRight: 10 }}
          />
          <p>
            {title ||
              t("messages.record.fileUploadMessage")}
          </p>
        </div>
      </div>
    </div>
  );
};

export default withStyles(styles, { withTheme: true })(Upload);
